export var ControlValuesLevelEnum;
(function (ControlValuesLevelEnum) {
    ControlValuesLevelEnum["WORKFLOW_CONTROLS"] = "workflow";
    ControlValuesLevelEnum["STEP_CONTROLS"] = "step";
})(ControlValuesLevelEnum || (ControlValuesLevelEnum = {}));
